
import { email, required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { getErrorMessage } from "@/helpers/validation";
import { ModuleNames } from "@/store";
import ClarityInput from "@/components/clarity/ClarityInput.vue";
import ClarityButton from "@/components/clarity/ClarityButton.vue";

export default Vue.extend({
  name: "ResetPasswordView",
  components: {
    ClarityButton,
    ClarityInput,
  },
  // middleware: ["is-guest"],
  validations: {
    email: {
      required,
      email,
    },
  },
  data: (): {
    email: string;
    formError: string;
    isLoading: boolean;
  } => ({
    email: "",
    formError: "",
    isLoading: false,
  }),
  computed: {
    ...mapGetters(ModuleNames.auth, { isAuthenticated: "isAuthenticated" }),
  },
  watch: {
    isAuthenticated: {
      immediate: true,
      handler(): void {
        if (this.isAuthenticated) {
          this.$router.push({ name: "account" });
        }
      },
    },
  },

  methods: {
    ...mapActions(ModuleNames.auth, ["resetPassword"]),
    getErrorMessage(validation: any): string {
      return getErrorMessage(validation);
    },
    async resetUserPassword(): Promise<void> {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$noty.error(this.$t("formContainsErrors") as string);
        return;
      }
      this.isLoading = true;
      try {
        await this.resetPassword({ email: this.email });
        this.$noty.success("Wysłano email. Sprawdź skrzynkę pocztową");
        this.email = "";
        this.formError = "";
      } catch (e: any) {
        this.$noty.error(this.$t("formContainsErrors") as string);
        this.formError = this.$t(e.message) as string;
      } finally {
        this.isLoading = false;
      }
    },
  },
});
